import styled from "styled-components";

export const IdentificationContent = styled.div`
  margin-top: 14px;
`;

export const Metadada = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;

  img{
    padding-right: 7px;
  }

  span {
    font-size: 18px;
  }
`;